import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取商品可见性列表 #10046 */
export function getGoodsVisibleList(data) {
  return request("".concat(BASE_URL) + "/product/view/list", METHOD.GET, data);
}

/* 删除商品可见性 #10047 */
export function deleteGoodsVisibleByid(productOptionId) {
  return request("".concat(BASE_URL) + "/product/view/" + productOptionId, METHOD.DELETE);
}
/* 新建/编辑 保存商品可见性（#10039） */
export function saveAddEdit(data) {
  return request("".concat(BASE_URL) + "/product/view", METHOD.POST, data);
}

/* 可见性配置保存得意先接口（#10036） */
export function saveErp(data) {
  return request("".concat(BASE_URL) + "yy/product/view", METHOD.PUT, data);
}

/* 获取商品可见性详情（#10048） */
export function getGoodsVisibleDetail(productOptionId) {
  return request("".concat(BASE_URL) + "/product/view/detail/?productOptionId=" + productOptionId, METHOD.GET);
}
export default {
  getGoodsVisibleList: getGoodsVisibleList,
  deleteGoodsVisibleByid: deleteGoodsVisibleByid,
  saveAddEdit: saveAddEdit,
  saveErp: saveErp,
  getGoodsVisibleDetail: getGoodsVisibleDetail
};